import { EXTEND_ENV } from '@helloextend/client-constants'

export function isEnv(envs: string[]): boolean {
  return envs.some(env => env === EXTEND_ENV)
}
